import { render, staticRenderFns } from "./MailingTranslationNewPopup.vue?vue&type=template&id=4f71e1fc&"
import script from "./MailingTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./MailingTranslationNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./MailingTranslationNewPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports